import React from 'react';
import { Card, Form, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { USER } from '../../../utils/constants';
import Button from '../../components/Button';
import useBreakpoint from '../../hooks/useBreakpoint';

export default function FormTemplate({
  title,
  handleSubmit,
  submitText,
  loading,
  children,
  user = USER.INFLUENCERS,
  hintText,
}) {
  const breakpoint = useBreakpoint();
  const { t } = useTranslation();

  return <Form onSubmit={handleSubmit}>
    <Card>
      <Card.Header>
        {
          ['xs', 'sm', 'md'].includes(breakpoint) ?
            <h4 className='mb-sm-4 mb-5'>
              {title}
            </h4> :
            <h3 className='mb-sm-4'>
              {title}
            </h3>
        }
      </Card.Header>
      <Card.Body className='mb-4-5'>
        {children}
      </Card.Body>
      <hr />
      {hintText && (
        <div className="form-text px-3 text-muted font-italic">
          <small>{hintText}</small>
        </div>
      )}
      <Card.Footer>
        <div className='flex flex-column align-items-end'>
          <Button
            id='sign-in-button'
            variant='primary'
            type="submit"
            disabled={loading}>
            {loading ? <Spinner animation="border" size="sm" /> : submitText}
          </Button>
          {
            user === USER.INFLUENCERS ?
              <div className='text-right text-1'>
                {t('common.pages.sign_in.no_account')}&nbsp;
                <Link to="/sign-up/step-1">
                  {t('influencers.common.sign_up')}
                </Link>
              </div> : null
          }
          <div className='text-right text-1'>
            {t('common.email_us_at')}&nbsp;
            <a href='mailto:questions@obvious.ly'>questions@obvious.ly</a>&nbsp;
            {user === USER.CLIENTS ? t('common.if_have_questions') : null}
          </div>
        </div>
      </Card.Footer>
    </Card>
  </Form>;
}